import { useReducer } from 'react';

function useStateMachine(initialState, machine) {
  return useReducer(
    (state, event) => {
      const nextState = machine[state][event];
      return nextState ?? state;
    },
    initialState
  );
}

export { useStateMachine };
//# sourceMappingURL=useStateMachine.mjs.map
